import { render, staticRenderFns } from "./ImporteConGd.vue?vue&type=template&id=cf88b900"
import script from "./ImporteConGd.vue?vue&type=script&setup=true&lang=js"
export * from "./ImporteConGd.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports